import ko from "knockout";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";
import { makeObservableIfNeeded } from "flow/koHelpers/makeObservable";

export default function createEnabler(enableObs?: MaybeObservable<boolean>, disableObs?: MaybeObservable<boolean>) {
    let resultingEnabler: KnockoutObservable<boolean>;

    if (enableObs !== undefined) {
        // If consumer has specified an enable function, use it
        resultingEnabler = makeObservableIfNeeded(enableObs);
    } else if (disableObs !== undefined) {
        // Else if it's a disable function, inverse it and use it as an enable function
        resultingEnabler = ko.pureComputed(() => !ko.unwrap(disableObs));
    } else {
        // Else always enable
        resultingEnabler = ko.observable(true);
    }

    return resultingEnabler;
}

export function createDisabler(enableObs?: MaybeObservable<boolean>, disableObs?: MaybeObservable<boolean>) {
    let resultingDisabler: KnockoutObservable<boolean>;

    if (enableObs !== undefined) {
        // If consumer has specified an enable function, use it
        resultingDisabler = ko.pureComputed(() => !ko.unwrap(enableObs));
    } else if (disableObs !== undefined) {
        // Else if it's a disable function, inverse it and use it as an enable function
        resultingDisabler = makeObservableIfNeeded(disableObs);
    } else {
        // Else always enable
        resultingDisabler = ko.observable(false);
    }

    return resultingDisabler;
}
